<template>
    <v-container class="pa-0" fluid>
        <v-container v-if="loading">
            <cardWait />
        </v-container>
        <v-card class="pa-2" v-if="!loading">
            <v-card-title class="pt-0 pb-2 justify-center"><h2>Accommodation Details</h2> <btn_component ref="info" :tooltip="detailTooltip" type="avatar_text" size="small" text="i" data="" @actionClick="showInfo"/></v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                The Accommodation Details are generated automatically, <b>this is a work in progress!</b><br> 
                They need to be uploaded to the "openai platform" (ChatGPT) before the assistants can use them.
                Use the <b>UPLOAD</b> button to upload the latest version.
            </v-card-text>
            <v-divider></v-divider>
            <v-row class="pa-4">
                <v-spacer></v-spacer>
                <span class="pl-4">
                    <btn_component ref="upload" tooltip="Upload to OpenAI" type="text" size="small" text="Upload" data="" @actionClick="uploadAll"/>
                </span>
                <span class="pl-4">
                    <v-btn class="primary" small @click="buildReport" :disabled="disableExport" color="success">
                        <v-icon small class="pr-2">mdi-microsoft-excel</v-icon>
                        <span>Export</span>
                    </v-btn>
                </span>                
                <!-- <v-btn class="primary" small @click="buildReport" :disabled="disableExport" color="success">
                    <v-icon small class="pr-2">mdi-microsoft-excel</v-icon>
                    <span class="pr-1">Export</span>
                </v-btn> -->
            </v-row>
            <v-divider></v-divider>
            <v-row>
                <v-col cols="6"><v-text-field v-model="search" label="Search accommodation details" single-line hide-details prepend-icon="mdi-magnify"></v-text-field></v-col>
                <!-- <v-col cols="3"><selector ref="language" :options="languageCodes" option_field="languageCodesSelected" label="Filter on language" :visibleChips=4 @updateData="updateData"/></v-col>
                <v-col cols="3"><selector ref="accommodation" :options="accommodationCodes" option_field="accommodationCodesSelected" label="Filter on accommodation" :visibleChips=4 @updateData="updateData"/></v-col> -->
            </v-row>
            <v-divider></v-divider>
            <v-data-table 
                :items="faqs" 
                :items-per-page="10" 
                :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
                :headers="headers"
                :search="search">
                <template v-slot:item="props">
                    <tr>
                        <!-- <td>{{ props.item.language }}</td> -->
                        <td>{{ props.item.accommodation }}</td>
                        <td><longTextView :long_text="props.item.description" :max_width="800"/></td>
                        <td>
                            <btn_component ref="uploadFaq" tooltip="Upload file" type="text" size="small" text="Upload file" :data="[props.item]" @actionClick="uploadFile"/>
                            <btn_component ref="viewFaq" tooltip="View file" type="text" size="small" text="View file" :data="props.item" @actionClick="viewFile"/>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <cardFaq ref="cardFaq" />
        <cardFaqUpload ref="cardFaqUpload" title="accommodation detail"/>
        <showProgress ref="showProgress"/>
    </v-container>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import longTextView from "@/components/ui/fields/longTextView.vue";
    // import selector from "@/components/ui/selectors/selector.vue";
    import showProgress from "@/components/showProgress.vue";

    import cardFaq from "@/components/syst/openai/cardFaq.vue";
    import cardWait from "@/components/syst/openai/cardWait.vue";
    import cardFaqUpload from "@/components/syst/openai/cardFaqUpload.vue";

    export default {
        components: {
            btn_component,
            longTextView,
            // selector,
            showProgress,
            cardFaq,
            cardWait,
            cardFaqUpload,
        },
        props: {
        },
        data() {
            return {
                loading: true,
                firstTime: true,
                disableExport: false,

                detailTooltip: "Copy of accommodation details. Any changes need to be made there",
                
                // languageCodes: [],
                // languageCodesSelected: [],
                
                // accommodationCodes: [],
                // accommodationCodesSelected: [],

                files: [],
                
                search: "",

                headers: [
                    // {text: 'Language', value: 'language', width: "50px", tdClass: 'align-text-top' },
                    {text: 'Accommodation', value: 'accommodation', width: "50px", tdClass: 'align-text-top'},
                    {text: 'Details', value: 'description', width: "800px", tdClass: 'align-text-top'},
                    {text: 'Actions', value: '', width: "50px", tdClass: 'align-text-top'},
                ],
                faqs: [],
                // filteredFaqs: [],
            }
        },
        mounted() {
            this.getDetailAccommodation();
        },
        methods: {
            getDetailAccommodation() {
                this.$axios.post("ares/json/ares/syst/openai/getDetailAccommodations.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getDetailAccommodations"
                    },
                    getDetailAccommodations: {
                    },
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.faqs = res.data.getDetailAccommodations.items;
                        this.files = res.data.getDetailAccommodations.files;
                        // this.languageCodes = res.data.getDetailAccommodation.languageKeuzes;
                        // this.accommodationCodes = res.data.getDetailAccommodation.accommodationKeuzes;
                        if (this.firstTime) {
                            // this.languageCodesSelected = res.data.getDetailAccommodation.languageKeuzes;
                            // this.accommodationCodesSelected = res.data.getDetailAccommodation.accommodationKeuzes;
                            this.firstTime = false;
                        }
                        // this.filterFaqs();
                        this.loading = false;
                    }
                });
            },
            uploadAll() {
                this.uploadFile(this.files);
            },
            uploadFile(files) {
                this.disableAll += 1;
                this.$refs.showProgress.open();
                this.$axios.post("ares/json/ares/syst/openai/uploadFileList.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "uploadFileList",
                    },
                    uploadFileList: files,
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                        this.disableAll -= 1;
                        this.$refs.showProgress.close();
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.uploadFileList.text,
                            color: res.data.uploadFileList.color,
                        });
                        this.$refs.showProgress.close();
                        this.disableAll -= 1;
                    }
                });
            },
            viewFile(item) {
                console.log(item);
                this.$refs.cardFaq.openDialog("Accommodation details " + item.accommodation, item.description);
            },
            actionClick(action) {
                switch (action) {
                    case "refresh":
                        this.getDetailAccommodations();
                        break;
                }
            },
            showInfo() {
            },
            buildReport() {
                this.disableExport = true;
                this.$refs.showProgress.open();
                this.$axios.post("ares/json/ares/syst/openai/excelExportDetailAccommodation.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "excelExportDetailAccommodation"
                    },
                    excelExportDetailAccommodation: {
                        // items: this.filteredFaqs,
                        items: this.faqs,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.$refs.showProgress.close();
                    } else {
                        window.open(res.data.excelExportDetailAccommodation.filename, '_blank');
                    }
                    this.$refs.showProgress.close();
                    this.disableExport = false;
                });
            },
        }
    };
</script> 

<style scoped>
    .align-text-top {
        vertical-align: top;
    }
</style>
